/**
 * Services file for CMS which invokes Kentico API endpoints or third party API for public site.
 */

const BASE_API_URL = '/api';
const BASE_JOIN_NOW_URL = `${BASE_API_URL}/join-now`;
const BASE_MEMBERSHIP_STATUS_URL = `${BASE_API_URL}/membership-status`;
const BASE_PAYMENT_STATUS_URL = `${BASE_API_URL}/payment-status`;

export default {
  COMMON: {
    GET_BUSINESS_HOURS: `${BASE_API_URL}/web-chat/openings`,
    GET_SEARCH_PREDICTION: `${BASE_API_URL}/search/suggestions`,
    POST_REBATE_FORM_UPLOAD: (memberNumber, fileName, dateTimeStamp) => {
      return `${BASE_API_URL}/rebates/${memberNumber}/form-upload?fileName=${fileName}&dateTimeStamp=${dateTimeStamp}`;
    },
  },

  // Public website homepage
  HOMEPAGE_PW: {
    GET_REFERENCE_DATA: `${BASE_API_URL}/home/reference-data`,
    GET_MAINTENANCE_DATA: `${BASE_API_URL}/home/maintenance-reference-data`,
  },

  // Member Portal homepage
  HOMEPAGE_MP: {
    GET_REFERENCE_DATA: `${BASE_API_URL}/home/portal/reference-data`,
    GET_MEMBERSHIP_INFO: (memberNumber) => {
      return `${BASE_API_URL}/home/portal/membership/${memberNumber}`;
    },
  },

  ADDRESS_VALIDATION: {
    GET_ADDRESS_URL: 'https://kleber.datatoolscloud.net.au/KleberWebService/DtKleberService.svc/ProcessQueryStringRequest',
    REQUEST_KEY: 'RK-CEB63-406DF-E4F37-3C038-8DA3B-CB567-D023C-73E2E',
    METHOD: {
      // To get predictive address list
      PREDICTIVE: 'DataTools.Capture.Address.Predictive.AuPaf.SearchAddress',

      // To retrieve full address details
      FULL: 'DataTools.Capture.Address.Predictive.AuPaf.RetrieveAddress',
    },
  },

  JOIN_NOW: {
    GET_MAINTENANCE_DATA: `${BASE_API_URL}/home/maintenance-reference-data`,
    GET_REFERENCE_DATA: BASE_JOIN_NOW_URL,
    GET_QUOTE_DETAILS: `${BASE_API_URL}/needs-analysis/quote/#{quoteID}`,
    UPLOAD_FILE: `${BASE_API_URL}/contact/#{contactIdOrMemberNumber}/file/fileCategory/`,
    GET_PRODUCT_PRICE: `${BASE_API_URL}/quote-price/calculate-price`,
    CONVERT_STT: `${BASE_JOIN_NOW_URL}/convert-stt/#{stt}`,
    CREATE_MEMBERSHIP: `${BASE_JOIN_NOW_URL}/CreateMembership`, // FIXME: Rename to create-membership once BE changes are complete
    POST_JOIN_NOW_WORK_ITEM: `${BASE_JOIN_NOW_URL}/work-item`,
  },

  MEMBERSHIP_STATUS: {
    GET_REFERENCE_DATA: BASE_MEMBERSHIP_STATUS_URL,
    GET_PRORATA_PRICE: (memberNumber) => {
      return `${BASE_MEMBERSHIP_STATUS_URL}/prorata-price/membership/${memberNumber}`;
    },
    SUBMIT_PAYMENT_REQUEST: (memberNumber) => {
      return `${BASE_MEMBERSHIP_STATUS_URL}/register-payment/membership/${memberNumber}`;
    },
    GET_PREMIUM_ADJUSTMENTS: (memberNumber, showPremiumPaymentAmount, currentDate, startDateCatchUp) => {
      return `${BASE_MEMBERSHIP_STATUS_URL}/premium-adjustments/${memberNumber}?showPremiumPaymentAmount=${showPremiumPaymentAmount}&currentDate=${currentDate}&startDateCatchUp=${startDateCatchUp}`;
    },
  },

  PAYMENT_STATUS: {
    GET_REFERENCE_DATA: BASE_PAYMENT_STATUS_URL,
  },

  API_ERROR_STATUS_CODES: {
    ERROR_PAGE: [408, 409, 500, 502, 503, 504],
    NOT_FOUND: [404],
  },
  SUPPORT: {
    CONTACT_US: {
      GET_REFERENCE_DATA: `${BASE_API_URL}/contact-us/public`,
      POST_FEEDBACK: `${BASE_API_URL}/contact-us/submit`,
      GET_CONFIRMATION_REFERENCE_DATA: `${BASE_API_URL}/contact-us/public/confirmation`,
    },
  },
};
